import { pick } from 'lodash'
import type { init } from 'stores/_utils/simple-store'
import type { TPersistentStoreName } from '../persistenceStoresCleanUpMap'
import { persistStoreState } from './persistStoreState'

export const subscribeToStoreForPersistedState = <TPersistentInitState extends Record<string, unknown>>({
  keysToPutInPersistentStorage,
  store,
  storeName,
}: {
  keysToPutInPersistentStorage: Record<keyof TPersistentInitState, boolean>
  store: ReturnType<typeof init<TPersistentInitState>>
  storeName: TPersistentStoreName
}) => {
  const keysToListenTo: (keyof TPersistentInitState)[] = Object.keys(keysToPutInPersistentStorage).filter(
    (key) => keysToPutInPersistentStorage[key],
  )

  store.subscribeToChanges(
    (s) => pick(s, keysToListenTo),
    (state) => {
      persistStoreState(storeName, state)
    },
  )
}
